export const SET_REPORT_VALUE = '@@REPORT_VIEW/SET_REPORT_VALUE';